export const SET_LOCATION_LOADING = 'SET_LOCATION_LOADING'
export const SET_ASSIGN_LOCATION = 'SET_ASSIGN_LOCATION'
export const SET_LOCATION = 'SET_LOCATION'
export const ADD_LOCATION = 'ADD_LOCATION'
export const EDIT_LOCATION = 'EDIT_LOCATION'
export const DELETE_LOCATION = 'DELETE_LOCATION'
export const SET_LOCATION_COUNT = 'SET_LOCATION_COUNT'
export const SET_BUSSINESS_CATEGORIES = 'SET_BUSSINESS_CATEGORIES'
export const SET_BUSSINESS_TYPES = 'SET_BUSSINESS_TYPES'